import React from "react";

const SongSorter = ({ sortMode, setSortMode }) => {
  const buttons = [
    { label: "Recent", value: "recent" },
    { label: "Likes", value: "likes" },
    { label: "Clicks", value: "clicks" },
    { label: "Plays", value: "plays" },
  ];

return (
  <div
    style={{
      background: "rgba(0, 0, 0, 0.6)",
      padding: "8px",
      borderRadius: "10px",
      color: "white",
      textAlign: "center",
    }}
  >
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "6px",
      }}
    >
      {buttons.map(button => (
        <button
          key={button.value}
          onClick={() => setSortMode(button.value)}
          style={{
            padding: "6px 5px",
            borderRadius: "5px",
            border:
              sortMode === button.value
                ? "2px solid #FFD700"
                : "1px solid #FF8C00",
            background: sortMode === button.value ? "#FFD700" : "#222",
            color: sortMode === button.value ? "black" : "white",
            cursor: "pointer",
            fontWeight: "900",
            fontSize: "0.72rem",
            fontFamily: '"Courier New", monospace',
          }}
        >
          {button.label.toUpperCase()}
        </button>
      ))}
    </div>
  </div>
);
};
export default SongSorter;
